// @flow
import EAWTable from './EAWTable';

export default EAWTable;
